module.exports = __webpack_public_path__ + "static/img/shop.7d08720d.png";